<template>
  <div class="kaisha-and-footer">
    <section id="kaisha" class="kaisha">
      <div id="aisatsu">
        <div id="aisatsu_text">
          <h1 class="title">美の発展に貢献し続ける</h1>
          <pre>
お客様によりご満足いただけるように、
お客様の声に耳を傾け、
お客様のニーズにあった製品やサービスを
提供する企業であり続けたいと思っています。
          </pre>
          <p>
            世界中を旅した末、ご縁があり1987年に来日しました。         私の母国であるスウェーデンで世界初の「光脱毛機」に出会い、それを機に1998年に現在の株式会社スカンジナビアサービスの前身である株式会社スカンジナビアを創業しました。
          </p>
          <p>
            当時の日本の脱毛はワックスとニードルしかありませんでした。
          </p>
          <p> 自社で開発した「POWERLITE<sup>®</sup>」はスピーティで痛みがない画期的な施術であり、さらにリーズナブルに受けられることで顧客の満足度も高く、本当に多くのサロン様やクリニック様に導入していただきました。
          </p>
          <p>           現在でも機器の信頼性と機能性に高い評価をいただいており、さらに修理が迅速であることも当社の誇りとするところであります。
          </p>
          <p> 私たちは「美の発展に貢献し続ける」をモットーに、今後一層の努力を重ねてまいります。従来と変わらぬご支援を賜りますようお願い申し上げます。
          </p>
        </div>
        <div id="aisatsu_photo">
          <img class="peter" src="/assets/img/_MG_2696_600x819.png" alt="代表取締役 北条ピーター">
          <div class="caption">
            株式会社スカンジナビアサービス<br>
            代表取締役 北条ピーター<br>
            スウェーデン商工会議所理事<br>
            一般社団法人 日本エステティック工業会理事
          </div>
          <br>
          <img class="autograph" src="/assets/img/petersign2-W3.png" alt="代表取締役 北条ピーターのサイン">
        </div>
      </div>
      <div id="outline">
        <div id="outline_text">
          <h2>会社概要</h2>
          <div id="okagesama"><img src="/assets/img/left-branch.svg" alt="左枝"><div class="okagesama-text"> おかげ様で設立<span>28</span>年目を迎えます</div><img src="/assets/img/right-branch.svg" alt="右枝"></div>
          <dl>
            <dt>会社名</dt>
            <dd>株式会社スカンジナビアサービス <br>Scandinavia Service Co., Ltd.</dd>
            <dt>本社</dt>
            <dd>〒153-0061 東京都目黒区中目黒3丁目3番2号</dd>
            <dt>福岡支店</dt>
            <dd>〒810-0073 福岡県福岡市中央区舞鶴1-8-39<br>オフィスニューガイアクレール天神Ⅱ 7F</dd>
            <dt>設立年</dt>
            <dd>2013年5月</dd>
            <dt>資本金</dt>
            <dd>500万円</dd>
            <dt>事業内容</dt>
            <dd>美容機器の製造販売・化粧品製造販売、輸出入</dd>
            <dt>加盟団体</dt>
            <dd>一般社団法人 日本エステティック工業会 正会員理事<br>在日スウェーデン商工会議所 副会頭</dd>
            <dt>TEL</dt>
            <dd><a href="tel:0357682921">03-5768-2921</a></dd>
            <dt>FAX</dt>
            <dd>03-5768-2925</dd>
            <dt>Email</dt>
            <dd>info@scandinavianbeauty.jp</dd>
          </dl>
        </div>
        <div id="outline_map">
          <img src="/assets/img/map.png" alt="スカンジナビアサービス地図">
          <img class="egbuilding" src="/assets/img/26994.jpg" alt="スカンジナビアサービスがあるEGビル">
        </div>
      </div>
      <div id="history">
        <div id="history_text">
          <h2>沿革</h2>
          <dl>
            <dt>2013 </dt>
            <dd>株式会社スカンジナビアサービス設立</dd>
            <dt> </dt>
            <dd>Cellu-D<sup>®</sup>発表</dd>
            <dt> </dt>
            <dd>テレビ大阪の番組でHAIRMEDIC<sup>®</sup>システム紹介</dd>
            <dt>2014 </dt>
            <dd>Dr.PRO 発表</dd>
            <dt> </dt>
            <dd>スウェーデン旅行へキャンペーンにてご招待</dd>
            <dt>2015 </dt>
            <dd>SP300 LUXURY<sup>®</sup>発表</dd>
            <dt> </dt>
            <dd>EVOLUTION<sup>®</sup>発表</dd>
            <dt> </dt>
            <dd>代表取締役北条ピーターが在日スウェーデン商工会議所副理事に就任</dd>
            <dt>2016 </dt>
            <dd>EVOLUTION SLIM<sup>®</sup>発表</dd>
            <dt> </dt>
            <dd>SMART DREN<sup>®</sup>発表</dd>
            <dt> </dt>
            <dd>タイ旅行へキャンペーンにてご招待表</dd>
            <dt>2017 </dt>
            <dd>Dr.PRO HS発表</dd>
            <dt> </dt>
            <dd>Scandinavia News Vol. 1 発行</dd>
            <dt> </dt>
            <dd>Beauty World Hong Kong 参加</dd>
            <dt>2018 </dt>
            <dd>Smart Dren DUAL 発表</dd>
            <dt> </dt>
            <dd>Scandinavia News Vol. 2 発行</dd>
            <dt> </dt>
            <dd>ウェブサイトをリニューアル</dd>
            <dt>2019 </dt>
            <dd>Dr-PRO SLIM 発表</dd>
            <dt> </dt>
            <dd>Dr-PRO BeautySecret 発表</dd>
            <dt> </dt>
            <dd>Dr-PRO SilkyBright 発表</dd>
            <dt> </dt>
            <dd>Dr-PRO SilkyWash 発表</dd>
            <dt> </dt>
            <dd>ビューティーワールドジャパン出展</dd>
            <dt> </dt>
            <dd>スウェーディッシュビューティーフェイスティバル出展</dd>
            <dt> </dt>
            <dt>2020 </dt>
            <dd>ベースボールスポーツメディスンカンファレンス出展</dd>
            <dt>2021 </dt>
            <dd>ビューティーワールドジャパン福岡出展</dd>
            <dt> </dt>
            <dd>ヘルス＆ビューティーショー出展</dd>
            <dt> </dt>
            <dd>インターナショナルギフトショー東京出展</dd>
            <dt> </dt>
            <dd>レジャー＆サービス産業展 出展</dd>
            <dt> </dt>
            <dd>スポルテック2021出展</dd>
            <dt> </dt>
            <dd>スウェーディッシュビューティーフェイスティバル出展</dd>
            <dt> </dt>
            <dd>MAG BLADE発表</dd>
            <dt>2022 </dt>
            <dd>SW BEAUTY JET 発表</dd>
            <dt> </dt>
            <dd>MAGBLADE m 発表</dd>
            <dt> </dt>
            <dd>ビューティーワールドジャパン出展</dd>
            <dt> </dt>
            <dd>HOTERES EXPO2022出展</dd>
            <dt> </dt>
            <dd>レジャー＆サービス産業展 出展</dd>
            <dt> </dt>
            <dd>コスモプロフアジア シンガポール2022出展</dd>
            <dt>2023 </dt>
            <dd>創業25周年</dd>
            <dt> </dt>
            <dd>ビューティーワールドジャパン出展</dd>
            <dt> </dt>
            <dd>インターナショナルギフトショー出展</dd>
            <dt> </dt>
            <dd>Dr-MEDIC コンプレッションシリーズ発売</dd>
            <dt> </dt>
            <dd>コスモボーテ出展</dd>
            <dt> </dt>
            <dd>フェムテック東京出展</dd>
            <dt> </dt>
            <dd>レジャー＆サービス産業展 出展</dd>
            <dt> </dt>
            <dd>ビューティーワールドミドルイースト出展</dd>
            <dt>2024 </dt>
            <dd>ビューティーワールドジャパン出展</dd>
            <dt> </dt>
            <dd>インターナショナルギフトショー京都出展</dd>
            <dt> </dt>
            <dd>コスモボーテベトナム出展</dd>
            <dt> </dt>
            <dd>KILO-MINUS発表</dd>
            <dt>2025 </dt>
            <dd>ビューティーワールドジャパン出展</dd>
            <dt> </dt>
            <dd>SW BEAUTY JET Jr.発表</dd>
          </dl>
        </div>
      </div>
    </section>
    <div class="graypage" >
      <div class="page_content">
        <aboutus></aboutus>
        <shop-movie-partner></shop-movie-partner>
      </div>
    </div>
    <footer2></footer2>
  </div>
</template>

<script>
 export default {
   name: 'kaisha',
   components: {
     'shop-movie-partner': () => import('../components/ShopMoviePartner.vue'),
     footer2: () => import('../components/Footer2.vue'),
     aboutus: () => import('../components/AboutUs.vue'),

   },
 }
</script>

<style lang="scss" scoped>
 $dropdownmenu-bgcolor: #aaa;
 $menutype-color: #555;
 $menutype-color-eng: $dropdownmenu-bgcolor;
 $page-width: 960px;

 #kaisha {
   width: $page-width;
   margin: 0 auto;
   display:flex;
   flex-direction: column;

   #aisatsu {
     display: flex;
     font-size: 0.8em;
     #aisatsu_text {
       padding: 20px 40px 0 40px;
       flex: 2;
       h1.title {
         width: 500px;
         font-size: 2em;
         font-family: sans-serif;
         color: #e1c410;
         margin-top: 0;
         margin-bottom: 10px;
       }
       pre {
         font-family: serif;
         font-size: 1em;
         line-height: 2.2em;
         padding: 0;
         margin: 0;
         background: white;
       }
     }
     #aisatsu_photo {
       flex: 1 1 0;
       align-items: flex-start;
       align-content: flex-start;
       margin: 20px 20px 0 20px;
       img.peter {
         background: #ddd;
         display: block;
         margin: 0;
         width: 300px;
       }
       .caption {
         white-space: pre;
       }
       img.autograph {
         // display: block;
         margin-top: -10px;
         width: 300px;
       }
     }
   }

   #outline {
     margin-top: 50px;
     display: flex;
     #outline_text {
       // flex-basis: 460px;
       flex-basis: 55%;
       font-size: 0.8em;
       h2 {
         padding-left: 15px;
       }
       #okagesama {
         display: flex;
         margin-top: 10px;
         margin-left: 50px;
         align-items: center;
         .okagesama-text {
           font-family: serif;
           font-size: 20px;
           color: #666;
           margin-left: 10px;
           margin-right: 10px;
           span {
             font-size: 40px;
           }
         }
         img {
           display: block;
           height: 40px;
           /* padding-top: 10px; */
         }
       }
       dl {
         /* border: 3px double #ccc; */
         padding: 10px;
       }
       dt {
         float: left;
         clear: left;
         width: 70px;
         text-align: right;
         font-weight: bold;
         color: #47a3da;
       }
       dt::after {
         content: ":";
       }
       dd {
         margin: 0 0 0 80px;
         padding: 0 0 0.5em 0;
       }
     }
     #outline_map {
       display: flex;
       flex-direction: column;
       align-items: center;
       img {
         // width: 400px;
         width: calc($page-width * 45 / 100);
         background: aqua;
       }
       img.egbuilding {
         margin-top: -30px;
         margin-right: 20px;
         width: 100px;
         align-self: flex-end;
       }
     }
   }
   #history {
     // width: 500px;
     margin: 50px auto 20px;
     #history_text {
       h2 {
         margin-bottom: 10px;
       }
       line-height: 1.2em;
       flex-basis: 500px;
       font-size: 0.8em;
       h2 {
         padding-left: 15px;
       }
       dl {
         /* border: 3px double #ccc; */
         padding: 10px;
       }
       dt {
         float: left;
         clear: left;
         width: 40px;
         text-align: right;
         font-weight: bold;
         color: #444;
       }
       dt::after {
         content: " ";
       }
       dd {
         margin: 0 0 0 50px;
         padding: 0 0 0.5em 0;
       }
     }
   }
 }
 @media (min-width: 601px) {
   #kaisha {
     margin-top: 80px; /* to deal with floating menu*/
   }
 }
 @media screen and (max-width: 600px) {
   #kaisha {
     width: 100%;
     #aisatsu {
       flex-direction: column;
       #aisatsu_text {
         padding: 20px 10px 0 10px;
         flex: 2;
         h1.title {
           font-size: 1.8em;
           font-family: sans-serif;
           color: #e1c410;
           margin-top: 0;
           margin-bottom: 10px;
         }
         pre {
           font-family: serif;
           font-size: 0.9em;
           line-height: 2.2em;
           padding: 0;
           margin: 0;
           background: white;
         }
       }

       #aisatsu_photo {
         flex: 1 1 0;
         align-items: flex-start;
         align-content: flex-start;
         margin: 20px 20px 0 20px;
         img.peter {
           background: #ddd;
           display: block;
           margin: 0;
           width: 100%;
         }
         .caption {
           white-space: pre;
         }
         img.autograph {
           // display: block;
           margin-top: -10px;
           width: 100%;
         }
       }
     }
     #outline {
       display: flex;
       flex-direction: column;
     }
     #history {
       width: 100%;
     }
   }
 }
</style>
